import React from 'react';
import { NavLink } from 'react-router-dom';
import { Home, Target, TrendingUp, PieChart, Building2, User, BarChart2 } from 'lucide-react';

const NAV_ITEMS = [
  { to: '/', icon: Home, label: 'Home', end: true },
  { to: '/goals', icon: Target, label: 'Goals' },
  { to: '/transactions', icon: TrendingUp, label: 'Trades' },
  { to: '/brokers', icon: Building2, label: 'Brokers' },
  { to: '/assets', icon: BarChart2, label: 'Assets' },
  { to: '/portfolio', icon: PieChart, label: 'Portfolio' },
  { to: '/profile', icon: User, label: 'Profile' },
];

const Navigation = () => {
  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 z-40 safe-bottom shadow-[0_-1px_16px_rgba(0,0,0,0.06)]">
      <div className="max-w-4xl mx-auto flex items-stretch">
        {NAV_ITEMS.map(({ to, icon: Icon, label, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center justify-center pt-2 pb-1 gap-0.5 transition-colors ${
                isActive ? 'text-blue-600' : 'text-gray-400 hover:text-gray-600'
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={`p-1.5 rounded-xl transition-all duration-200 ${
                    isActive ? 'bg-blue-50 scale-110' : ''
                  }`}
                >
                  <Icon
                    className="w-[18px] h-[18px]"
                    strokeWidth={isActive ? 2.5 : 1.8}
                  />
                </div>
                <span
                  className={`text-[9px] font-medium leading-none transition-colors ${
                    isActive ? 'text-blue-600' : 'text-gray-400'
                  }`}
                >
                  {label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

export default Navigation;
